/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'motorcycle': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 14',
    data: '<path pid="0" d="M19.44 4.03L15.41 0H11v2h3.59l2 2H5a4.951 4.951 0 0 0-5 5 4.951 4.951 0 0 0 5 5 4.931 4.931 0 0 0 4.9-4h1.65l2.77-2.77A4.882 4.882 0 0 0 14 9a4.951 4.951 0 0 0 5 5 4.951 4.951 0 0 0 5-5 4.922 4.922 0 0 0-4.56-4.97zM7.82 10A3.044 3.044 0 0 1 5 12a3.035 3.035 0 0 1-3-3 3.035 3.035 0 0 1 3-3 3.044 3.044 0 0 1 2.82 2H5v2zM19 12a3 3 0 0 1-3-3 3 3 0 0 1 3-3 3 3 0 0 1 3 3 3 3 0 0 1-3 3z" fill-rule="evenodd"/>'
  }
})
